module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic"
  }, [_c('ul', {
    staticClass: "dynamic-list"
  }, [_vm._l((_vm.listData), function(item, index) {
    return _c('li', {
      staticClass: "item"
    }, [(false) ? _c('div', {
      staticClass: "stage"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("—— 6月17日 20：15 物流运输已完成 ——")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "circle"
    }, [_c('img', {
      attrs: {
        "src": item.userAvatar,
        "alt": item.userName
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', {
      staticClass: "date-time"
    }, [_vm._v(_vm._s(_vm._f("formatTimeCompare")(item.addTime)))]), _vm._v(" "), _c('div', {
      staticClass: "infos"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), (item.images && item.images.length) ? _c('ul', {
      staticClass: "img-list"
    }, _vm._l((item.images), function(img) {
      return _c('li', {
        staticClass: "thumb",
        on: {
          "click": function($event) {
            _vm.openLightbox(img)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": img + '_80x80.jpg'
        }
      })])
    })) : _vm._e(), _vm._v(" "), (item.attchment && item.attchment.length) ? _c('div', {
      staticClass: "files"
    }, [_c('attachment-preview', {
      attrs: {
        "data": item.attchment
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_c('div', {
      staticClass: "item-options"
    }, [(_vm.isLikeShow === index) ? _c('like', {
      attrs: {
        "refId": item.id,
        "refType": "workOrder"
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "option",
      class: {
        'active': _vm.isLikeShow === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleLike(item.id, index, item.likeCount)
        },
        "mouseover": function($event) {
          _vm.showLike(index)
        },
        "mouseout": function($event) {
          _vm.hideLike()
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: [item.likeCount ? 'web-icon-thumbs-up' : 'web-icon-thumbs-up-o']
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("点赞"), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.likeCount),
        expression: "item.likeCount"
      }],
      staticClass: "num"
    }, [_vm._v("(" + _vm._s(item.likeCount) + ")")])])]), _vm._v(" "), _c('a', {
      staticClass: "option",
      class: {
        'active': _vm.isCommentShow === index
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.handleReport(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: [item.commentCount ? 'web-icon-comment' : 'web-icon-comment-o']
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v("评论"), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.commentCount),
        expression: "item.commentCount"
      }],
      staticClass: "num"
    }, [_vm._v("(" + _vm._s(item.commentCount) + ")")])])])], 1), _vm._v(" "), (_vm.isCommentShow === index) ? _c('div', {
      staticClass: "comment-con"
    }, [_c('report', {
      attrs: {
        "refId": _vm.id,
        "refCommentId": item.id,
        "refType": "workOrder"
      }
    })], 1) : _vm._e()])])
  }), _vm._v(" "), (!_vm.listData.length) ? _c('li', {
    staticClass: "empty"
  }, [_vm._v("暂无工单动态")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbe2a3d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/work-order/dynamic.vue
// module id = 1343
// module chunks = 82